var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"help-list"},_vm._l((_vm.helpList),function(item,index){return _c('div',{key:index,staticClass:"help-item"},[_c('div',{class:{'item-index':true,'tea-index':_vm.isTea}},[_vm._v(_vm._s(index + 1)+".")]),_c('div',[_vm._v(" "+_vm._s(item)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }